import React, { useState } from 'react';
import { useForm } from 'react-final-form';
import {
    required,
    Button,
    SaveButton,
    TextInput,
    useCreate,
    useNotify,
    FormWithRedirect,
    ReferenceInput,
    SelectInput
} from 'react-admin';
import { email } from 'ra-core'
import IconContentAdd from '@material-ui/icons/Add';
import IconCancel from '@material-ui/icons/Cancel';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

import constants from '../lib/constants'

function ConsumerModalCreate({ onChange }) {
    const [showDialog, setShowDialog] = useState(false);
    const [create, { loading }] = useCreate('consumers');
    const notify = useNotify();
    const form = useForm();

    const handleClick = () => {
        setShowDialog(true);
    };

    const handleCloseClick = () => {
        setShowDialog(false);
    };

    const handleSubmit = async values => {
        create(
            { payload: { data: values } },
            {
                onSuccess: ({ data }) => {
                    setShowDialog(false);
                    // Update the comment form to target the newly created consumer
                    // Updating the ReferenceInput value will force it to reload the available consumers
                    form.change('consumer_id', data.id);
                    onChange();
                },
                onFailure: ({ error }) => {
                    notify(error.message, 'error');
                }
            }
        );
    };

    return (
        <>
            <Button onClick={handleClick} label="ra.action.create">
                <IconContentAdd />
            </Button>
            <Dialog
                fullWidth
                open={showDialog}
                onClose={handleCloseClick}
                aria-label="Create Consumer"
            >
                <DialogTitle>Create Consumer</DialogTitle>

                <FormWithRedirect
                    resource={constants.RESOURCE_CONSUMERS}
                    save={handleSubmit}
                    render={({
                        handleSubmitWithRedirect,
                        pristine,
                        saving
                    }) => (
                        <>
                            <DialogContent className="consumerModalCreateContent">
                              <TextInput disabled source="id" />
                              <ReferenceInput source="organization_id" defaultValue={2} reference="organizations" label="Organization" perPage={-1} validate={required('Please select organization')}>
                                <SelectInput
                                  optionText="name"
                                  optionValue="id" />
                              </ReferenceInput>
                              <TextInput source="name" validate={required(constants.FIELD_MANDATORY)} />
                              <TextInput source="address" multiline validate={required(constants.FIELD_MANDATORY)} />
                              <TextInput source="email" validate={[required(constants.FIELD_MANDATORY),email("Please enter a valid email address")]} />
                              <div>
                                <h3>LOGO</h3>
                                <div style={{backgroundColor: 'lightgrey', borderRadius: '8px', padding: '10px', textAlign: 'center'}}>
                                  <p>Logo can be uploaded via editing Consumer after initial creation.</p>
                                </div>
                              </div>
                            </DialogContent>
                            <DialogActions>
                                <Button
                                    label="ra.action.cancel"
                                    onClick={handleCloseClick}
                                    disabled={loading}
                                >
                                    <IconCancel />
                                </Button>
                                <SaveButton
                                    handleSubmitWithRedirect={
                                        handleSubmitWithRedirect
                                    }
                                    pristine={pristine}
                                    saving={saving}
                                    disabled={loading}
                                />
                            </DialogActions>
                        </>
                    )}
                />
            </Dialog>
        </>
    );
}

export default ConsumerModalCreate;
